export enum ChunterEvents {
  MessageCreated = 'chunter.MessageCreated',
  MessageEdited = 'chunter.MessageEdited'
}
